import './tier-level.scss';

import { Outlet } from "react-router-dom";

import { FilterTierLevelProvider } from "./filter-tier-level/filter-tier-level.context";

export function TierLevel() {
  return (
    <div id="ShellTierLevel" className="tier-level">
       <FilterTierLevelProvider>
        <Outlet />
      </FilterTierLevelProvider>
    </div>
  );
}

export default TierLevel;
